import { NodeKind } from '../types';

export type MeshShape =
  | 'octahedron'
  | 'icosahedron'
  | 'torus'
  | 'box'
  | 'cylinder'
  | 'cone'
  | 'dodecahedron'
  | 'sphere';

export interface KindConfig {
  color: string;
  glowColor: string;
  mesh: MeshShape;
  clusterLabel: string;
}

export const KIND_CONFIG: Partial<Record<NodeKind, KindConfig>> & { _default: KindConfig } = {
  Template: {
    color: '#F59E0B',
    glowColor: '#FCD34D',
    mesh: 'octahedron',
    clusterLabel: 'Templates',
  },
  IKUCategory: {
    color: '#6366F1',
    glowColor: '#A5B4FC',
    mesh: 'icosahedron',
    clusterLabel: 'IKU Categories',
  },
  ReferenceCategory: {
    color: '#7C3AED',
    glowColor: '#C4B5FD',
    mesh: 'torus',
    clusterLabel: 'Reference Categories',
  },
  Device: {
    color: '#10B981',
    glowColor: '#6EE7B7',
    mesh: 'box',
    clusterLabel: 'Devices',
  },
  PimItem: {
    color: '#F97316',
    glowColor: '#FED7AA',
    mesh: 'cylinder',
    clusterLabel: 'PIM Items',
  },
  Service: {
    color: '#3B82F6',
    glowColor: '#93C5FD',
    mesh: 'cone',
    clusterLabel: 'Services',
  },
  Agent: {
    color: '#A855F7',
    glowColor: '#D8B4FE',
    mesh: 'dodecahedron',
    clusterLabel: 'Agents',
  },
  _default: {
    color: '#94A3B8',
    glowColor: '#CBD5E1',
    mesh: 'sphere',
    clusterLabel: 'Other',
  },
};

export function getKindConfig(kind: NodeKind): KindConfig {
  return KIND_CONFIG[kind] || KIND_CONFIG._default;
}

export const STATUS_GLOW: Record<string, string> = {
  ok: '#00ff88',
  warn: '#ffaa00',
  error: '#ff3333',
  unknown: '#94A3B8',
};

// Bloom levels
export const BLOOM_AMBIENT = { strength: 0.3, radius: 0.4, threshold: 0.85 };
export const BLOOM_SELECTED = { strength: 1.0, radius: 0.6, threshold: 0.1 };
export const BLOOM_ERROR = { strength: 0.6, radius: 0.5, threshold: 0.3 };

// Camera
export const FLY_TO_DURATION_MS = 1000;
export const FLY_TO_DISTANCE = 50;

// Auto-orbit
export const AUTO_ROTATE_SPEED = 0.5;

// LOD
export const LABEL_VISIBLE_DISTANCE = 300;
